import * as React from "react";
import styles from "./styles.module.scss";

interface ButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "type" | "onClick"> {
  children: any;
  className?: string;
  type: "fill" | "transparent" | "outline";
  onClick?: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, type, className, onClick, disabled, ...rest }, ref) => {
    const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      onClick?.(e);
    };

    return (
      <button
        {...rest}
        ref={ref}
        type="button"
        disabled={disabled}
        onClick={handleClick}
        className={`${styles.btn} ${styles[type]} ${className ?? ""}`}
      >
        {children}
      </button>
    );
  }
);

Button.displayName = "Button";

export { Button };
